import { render } from "./IdSelect.vue?vue&type=template&id=40d8a864"
import script from "./IdSelect.vue?vue&type=script&lang=js"
export * from "./IdSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__